import request from '@/utils/request'
import requestBlob from '@/utils/request-post-blob'

export const courseStudentLevel = (org_id) =>
  request({
    url: `/edu/studentLevel?org_id=${org_id}`,
    method: 'get'
  })
export const signPage = (org_id) =>
  request({
    url: `/page/edu-teacher-sign-page?org_id=${org_id}`,
    method: 'get'
  })
export const updataCourse = (data, upId) =>
  request({
    url: `/page/section/${upId}`,
    method: 'post',
    data
  })
export const exportCourse = (data, upId,t) =>
  requestBlob({
    url: `/page/section/excel/${upId}?t=${t}`,
    method: 'post',
    data
  })
export const coursePage = (org_id) =>
  request({
    url: `/page/edu-base-course-page?org_id=${org_id}`,
    method: 'get'
  })
export const subjectPage = (org_id) =>
  request({
    url: `/page/edu-subject-page?org_id=${org_id}`,
    method: 'get'
  })
export const packetPage = (org_id) =>
  request({
    url: `/page/edu-packet-page?org_id=${org_id}`,
    method: 'get'
  })
export const customerPage = (org_id) =>
  request({
    url: `/page/edu-customer-page?org_id=${org_id}`,
    method: 'get'
  })
export const studentPage = (org_id) =>
  request({
    url: `/page/edu-student-page?org_id=${org_id}`,
    method: 'get'
  })
export const businessPage = (org_id) =>
  request({
    url: `/page/edu-business-page?org_id=${org_id}`,
    method: 'get'
  })
export const orderPage = (org_id) =>
  request({
    url: `/page/edu-order-page?org_id=${org_id}`,
    method: 'get'
  })
export const employeePage = (org_id) =>
  request({
    url: `/page/edu-employee-page?org_id=${org_id}`,
    method: 'get'
  })
export const teacherPage = (org_id) =>
  request({
    url: `/page/edu_teacher_page?org_id=${org_id}`,
    method: 'get'
  })
export const campusPage = (org_id) =>
  request({
    url: `/page/campus-page?org_id=${org_id}`,
    method: 'get'
  })
export const courseTypePage = (org_id) =>
  request({
    url: `/page/edu-course-type-page?org_id=${org_id}`,
    method: 'get'
  })
export const courseLevelPage = (org_id) =>
  request({
    url: `/page/edu-course-level-page?org_id=${org_id}`,
    method: 'get'
  })
export const courseMaterialPage = (org_id) =>
  request({
    url: `/page/edu-material-page?org_id=${org_id}`,
    method: 'get'
  })
export const essentialPage = (org_id) =>
  request({
    url: `/page/edu-essential-page?org_id=${org_id}`,
    method: 'get'
  })
export const difficultyPage = (org_id) =>
  request({
    url: `/page/edu-difficulty-level-page?org_id=${org_id}`,
    method: 'get'
  })
export const instrumentPage = (org_id) =>
  request({
    url: `/page/edu-instrument-type-page?org_id=${org_id}`,
    method: 'get'
  })
export const urlTypePage = (url_type, org_id) =>
  request({
    url: `/page/${url_type}?org_id=${org_id}`,
    method: 'get'
  })
export const studentLevelPage = (org_id) =>
  request({
    url: `/page/edu-student-level-page?org_id=${org_id}`,
    method: 'get'
  })
export const customerSourcePage = (org_id) =>
  request({
    url: `/page/edu-customer-source-page?org_id=${org_id}`,
    method: 'get'
  })
export const teacherLevelPage = (org_id) =>
  request({
    url: `/page/edu-teacher-level-page?org_id=${org_id}`,
    method: 'get'
  })
export const bannerPage = (org_id) =>
  request({
    url: `/page/edu-banner-page?org_id=${org_id}`,
    method: 'get'
  })
export const articlePage = (org_id) =>
  request({
    url: `/page/edu-article-page?org_id=${org_id}`,
    method: 'get'
  })
export const agreementPage = (org_id) =>
  request({
    url: `/page/edu-agreement-page?org_id=${org_id}`,
    method: 'get'
  })
export const aboutPage = (org_id) =>
  request({
    url: `/page/edu-about-page?org_id=${org_id}`,
    method: 'get'
  })
export const cluePage = (org_id) =>
  request({
    url: `/page/edu-clue-page?org_id=${org_id}`,
    method: 'get'
  })
export const goodsSalePage = (org_id) =>
  request({
    url: `/page/edu-goods-sale-page?org_id=${org_id}`,
    method: 'get'
  })
export const goodsUsePage = (org_id) =>
  request({
    url: `/page/edu-goods-use-page?org_id=${org_id}`,
    method: 'get'
  })
export const goodsPage = (org_id) =>
  request({
    url: `/page/edu-goods-page?org_id=${org_id}`,
    method: 'get'
  })
export const options = (optionId, org_id) =>
  request({
    url: `/page/section/entity/${optionId}/option?org_id=${org_id}`,
    method: 'get'
  })
export const deleteItem = (data, optionId) =>
  request({
    url: `/page/section/entity/${optionId}`,
    method: 'delete',
    data
  })
export const addItem = (data, optionId) =>
  request({
    url: `/page/section/entity/${optionId}`,
    method: 'post',
    data
  })
export const addItemOrder = (data) =>
  request({
    url: `/edu/order`,
    method: 'post',
    data
  })
export const addItemCustomer = (data) =>
  request({
    url: `/edu/customer`,
    method: 'post',
    data
  })
export const editItem = (data, optionId) =>
  request({
    url: `/page/section/entity/${optionId}`,
    method: 'put',
    data
  })
export const editItemEnabled = (data, optionId) =>
  request({
    url: `/page/section/entity/enabled/${optionId}`,
    method: 'put',
    data
  })
export const editItemConnect = (data, optionId) =>
  request({
    url: `/edu/connectBusiness`,
    method: 'put',
    data
  })
export const studentDetail = (student_id) =>
  request({
    url: `/edu/studentDetail?student_id=${student_id}`,
    method: 'get'
  })
export const instrumentUse = (teacher_employee_id) =>
  request({
    url: `/edu/instrumentUse?teacher_employee_id=${teacher_employee_id}`,
    method: 'get'
  })
export const getSchoolCampus = (types, org_id) =>
  request({
    url: `/edu/employee?types=${types}&org_id=${org_id}`,
    method: 'get'
  })
export const studentUpdate = (data) =>
  request({
    url: `/edu/studentDetail`,
    method: 'post',
    data
  })
export const getInstrumentType = (org_id) =>
  request({
    url: `/edu/instrumentType?org_id=${org_id}`,
    method: 'get'
  })
export const studentRemark = (data) =>
  request({
    url: `/edu/studentRemark`,
    method: 'post',
    data
  })
export const studentCourse = (course_name, student_id, sign_student_level_id, student_level_id, course_type_id, teacher_id, sign_type, instrument_type_id, campus_id, start_time, end_time, is_formal, ages, page, size, is_distinct_student, packet_id) =>
  request({
    url: `/edu/studentCourse?course_name=${course_name}&student_id=${student_id}&sign_student_level_id=${sign_student_level_id}&student_level_id=${student_level_id}&course_type_id=${course_type_id}&teacher_id=${teacher_id}&sign_type=${sign_type}&instrument_type_id=${instrument_type_id}&campus_id=${campus_id}&start_time=${start_time}&end_time=${end_time}&is_formal=${is_formal}&ages=${ages}&page=${page}&size=${size}&is_distinct_student=${is_distinct_student}&packet_id=${packet_id}`,
    method: 'get'
  })
export const auditionCourseSign = (business_id, course_type_id, teacher_id, sign_type, instrument_type_id, campus_id, start_time, end_time, page, size) =>
  request({
    url: `/edu/auditionCourseSign?business_id=${business_id}&course_type_id=${course_type_id}&teacher_id=${teacher_id}&sign_type=${sign_type}&instrument_type_id=${instrument_type_id}&campus_id=${campus_id}&start_time=${start_time}&end_time=${end_time}&page=${page}&size=${size}`,
    method: 'get'
  })
export const getMaterial = (org_id, teacherEmployeeId, student_id) =>
  request({
    url: `/edu/material?teacherEmployeeId=${teacherEmployeeId}&org_id=${org_id}&student_id=${student_id}`,
    method: 'get'
  })
export const getEssentialMaterial = (org_id, teacherEmployeeId, student_id, instrument_type_id) =>
  request({
    url: `/edu/material?teacherEmployeeId=${teacherEmployeeId}&org_id=${org_id}&student_id=${student_id}&instrument_type_id=${instrument_type_id}`,
    method: 'get'
  })
export const baseCourse = (org_id, campus_id) =>
  request({
    url: `/edu/baseCourse?org_id=${org_id}&campus_id=${campus_id}`,
    method: 'get'
  })
export const getCourseSignList = (student_id, course_id, types, org_id) =>
  request({
    url: `/edu/courseSign?student_id=${student_id}&course_id=${course_id}&types=${types}&org_id=${org_id}`,
    method: 'get'
  })
export const getOrder = (student_id) =>
  request({
    url: `/edu/order?student_id=${student_id}`,
    method: 'get'
  })
export const getBusiness = (business_id, customer_id) =>
  request({
    url: `/edu/business?business_id=${business_id}&customer_id=${customer_id}`,
    method: 'get'
  })
export const getBusinessDetails = (business_id, is_show) =>
  request({
    url: `/edu/business?business_id=${business_id}&is_show=${is_show}`,
    method: 'get'
  })
export const getPacket = (packet_id) =>
  request({
    url: `/edu/packet?packet_id=${packet_id}`,
    method: 'get'
  })
export const packetList = () =>
  request({
    url: `/edu/packet`,
    method: 'get'
  })
export const saleGoodsList = (campus_id) =>
  request({
    url: `/edu/saleGoodsList?campus_id=${campus_id}`,
    method: 'get'
  })
export const getPacketData = (campus_id) =>
  request({
    url: `/edu/packet?campus_id=${campus_id}`,
    method: 'get'
  })
export const getOrderDetail = (order_id) =>
  request({
    url: `/edu/order?order_id=${order_id}`,
    method: 'get'
  })
export const modifyOrderDetail = (data) =>
  request({
    url: `/edu/order`,
    method: 'put',
    data
  })
export const getEssentialList = (subject_id) =>
  request({
    url: `/edu/essential?subject_id=${subject_id}`,
    method: 'get'
  })
export const getSubject = (packet_id) =>
  request({
    url: `/edu/subject?packet_id=${packet_id}`,
    method: 'get'
  })
export const customeInfo = (customer_id) =>
  request({
    url: `/edu/customer?customer_id=${customer_id}`,
    method: 'get'
  })
export const deleteStudentValue = (student_id, subject_id) =>
  request({
    url: `/edu/studentValue?student_id=${student_id}&subject_id=${subject_id}`,
    method: 'delete'
  })
export const getAllTheme = (instrument_type_id) =>
  request({
    url: `/edu/subject?instrument_type_id=${instrument_type_id}`,
    method: 'get'
  })
export const addAllTheme = (data) =>
  request({
    url: `/edu/studentValue`,
    method: 'post',
    data
  })
export const upleveldate = (data) =>
  request({
    url: `/edu/completionlevel`,
    method: 'post',
    data
  })
export const studentLocked = (data) =>
  request({
    url: `/edu/studentLocked`,
    method: 'post',
    data
  })
export const employeeDetail = (employee_id) =>
  request({
    url: `/edu/employeeDetail?employee_id=${employee_id}`,
    method: 'get'
  })
export const essentialList = (data) =>
  request({
    url: `/edu/essential`,
    method: 'post',
    data
  })
export const getAllTeacher = (is_all) =>
  request({
    url: `/edu/teacher?is_all=${is_all}`,
    method: 'get'
  })
export const alertEssential = (level) =>
  request({
    url: `/edu/essential?level=${level}`,
    method: 'get'
  })
export const newEssential = (data) =>
  request({
    url: `/edu/essential`,
    method: 'put',
    data
  })
  export const readAgreement = () =>
    request({
      url: `/edu/readAgreement`,
      method: 'get',
    })
  export const logsList = (employee_id, data_id, table_name, type, start_time, end_time, page, size, data_name, data_content_name) =>
    request({
      url: `/edu/logs?employee_id=${employee_id}&data_id=${data_id}&table_name=${table_name}&type=${type}&start_time=${start_time}&end_time=${end_time}&page=${page}&size=${size}&data_name=${data_name}&content=${data_content_name}`,
      method: 'get',
    })
  export const modifyLogs = (data) =>
    request({
      url: `/edu/logs`,
      method: 'post',
      data
    })
  export const deleteStudentRemark = (id) =>
    request({
      url: `/edu/studentRemark?id=${id}`,
      method: 'delete',
    })
  export const editStudentRemark = (data) =>
    request({
      url: `/edu/studentRemark`,
      method: 'put',
      data
    })
  export const getCustomerPhoneInfo = (phone) =>
    request({
      url: `/edu/customerList?phone=${phone}`,
      method: 'get',
    })
  export const getOptionId = () =>
    request({
      url: `/page/get_section/edu-order-page`,
      method: 'get',
    })
  export const selectHistory = (page_name) =>
    request({
      url: `/edu/selectHistory?page_name=${page_name}`,
      method: 'get',
    })
  export const feedbackStatus = (data) =>
    request({
      url: `/edu/feedback`,
      method: 'put',
      data
    })
  export const eduClueStatus = (data) =>
    request({
      url: `/edu/handleClue`,
      method: 'put',
      data
    })
  export const updateSortColor = (data) =>
    request({
      url: `/edu/updateSortColor`,
      method: 'put',
      data
    })
  export const setHistory = (data,page_key ) =>
    request({
      url: `/page/set_history/${page_key}`,
      method: 'post',
      data
    })
  export const customerDetail = (customer_id ) =>
    request({
      url: `/edu/customerDetail?customer_id=${customer_id}`,
      method: 'get',
    })
  export const pageLogs = ( data_id, page_name ) =>
    request({
      url: `/edu/pageLogs?data_id=${data_id}&page_name=${page_name}`,
      method: 'get',
    })
  export const customerMap = () =>
    request({
      url: `/edu/customerMap`,
      method: 'get',
    })
  export const upPicture = (data) =>
    request({
      url: `/edu/uploadFile`,
      method: 'post',
      data
    })
  export const courseSignLoges = (student_id, page, size) =>
    request({
      url: `/edu/courseSign/logs?student_id=${student_id}&page=${page}&size=${size}`,
      method: 'get',
    })
  export const getPerformance = (types, campus, teacher, start_time, end_time) =>
    request({
      url: `/edu/performance?types=${types}&campus_id=${campus}&employee_id=${teacher}&start_time=${start_time}&end_time=${end_time}`,
      method: 'get',
    })
  export const putFeedback = (data) =>
    request({
      url: `/edu/feedback`,
      method: 'put',
      data
    })
  export const addGoods = (data) =>
    request({
      url: `/edu/goods`,
      method: 'post',
      data
    })
  export const getGoods = (id) =>
    request({
      url: `/edu/goods?id=${id}`,
      method: 'get',
    })
  export const getGoodsDetails = (id) =>
    request({
      url: `/edu/goodsInfo?info_id=${id}`,
      method: 'get',
    })
  export const editGoods = (data) =>
    request({
      url: `/edu/goods`,
      method: 'put',
      data
    })
  export const updateGoodsStatus = (data) =>
    request({
      url: `/edu/updateGoodsStatus`,
      method: 'post',
      data
    })
  export const updateGoodsInfo = (data) =>
    request({
      url: `/edu/goodsInfo`,
      method: 'put',
      data
    })
  export const messageTemplate = () =>
    request({
      url: `/edu/messageTemplate`,
      method: 'get',
    })
  export const getMessageTask = (template_id, id, employee_id, name, page, size) =>
    request({
      url: `/edu/messageTask?template_id=${template_id}&id=${id}&employee_id=${employee_id}&name=${name}&page=${page}&size=${size}`,
      method: 'get',
    })
  export const messageTaskPost = (data) =>
    request({
      url: `/edu/messageTask`,
      method: 'post',
      data
    })
  export const messageTaskPut = (data) =>
    request({
      url: `/edu/messageTask`,
      method: 'put',
      data
    })
  export const getMessageTaskDetails = (id) =>
    request({
      url: `/edu/messageTask?id=${id}`,
      method: 'get'
    })
  export const deleteMessageTask = (id) =>
    request({
      url: `/edu/messageTask?id=${id}`,
      method: 'delete'
    })
  export const getRecordList = (template_id, phone, name, page, size) =>
    request({
      url: `/edu/messageDetail?template_id=${template_id}&phone=${phone}&name=${name}&page=${page}&size=${size}`,
      method: 'get'
    })
  export const getGoodsBand = () =>
    request({
      url: `edu/goodsBrand`,
      method: 'get'
    })
  export const putRecordList = (data) =>
    request({
      url: `/edu/messageDetail?id=${data.id}`,
      method: 'put',
      data
    })
  export const messageEnable = (data) =>
    request({
      url: `/edu/messageNoticeEnable?is_enabled=${data.is_enabled}`,
      method: 'put',
      data
    })
  export const eduupdateSubjectSort = (data) =>
    request({
      url: `/eduupdateSubjectSort`,
      method: 'put',
      data
    })
  export const eduupdateEssentialSort = (data) =>
    request({
      url: `/eduupdateEssentialSort`,
      method: 'put',
      data
    })
  export const messageNoticeEnable = () =>
    request({
      url: `/edu/messageNoticeEnable`,
      method: 'get'
    })
  export const getPacketBaseCourse = (packet_id) =>
  request({
    url: `/edu/packetBaseCourse?packet_id=${packet_id}`,
    method: 'get'
  })
  export const getBaseCourseAll = () =>
  request({
    url: `/edu/baseCourse/all`,
    method: 'get'
  })
  export const PacketBaseCourse = (data) =>
  request({
    url: `/edu/packetBaseCourse`,
    method: 'post',
    data
  })
  export const updatePacketBaseCourse = (data) =>
  request({
    url: `/edu/packetBaseCourse`,
    method: 'put',
    data
  })
  export const updatePacketBaseCourseSort = (data) =>
  request({
    url: `/edu/updatePacketBaseCourseSort`,
    method: 'put',
    data
  })
  export const baseCourseDetail = (base_course_id) =>
  request({
    url: `/edu/baseCourse/detail?base_course_id=${base_course_id}`,
    method: 'get'
  })
  export const deletePacketBaseCourse = (data) =>
  request({
    url: `/edu/packetBaseCourse`,
    method: 'delete',
    data
  })
  export const getBaseCourseByCourseID = (course_id) =>
  request({
    url: `/edu/baseCourseByCourseID?_id=${course_id}`,
    method: 'get'
  })
  export const getCourseByID = (course_id) =>
  request({
    url: `/edu/course?types=edit_info&course_id=${course_id}`,
    method: 'get'
  })

  export const reserveCourseSign = (data) =>
  request({
    url: `/edu/courseSign/reserve`,
    method: 'post',
    data
  })
  export const PacketBaseCourseTrue = (packet_id, base_course_id) =>
  request({
    url: `/edu/packetBaseCourse/true?packet_id=${packet_id}&base_course_id=${base_course_id}`,
    method: 'get',
  })
  export const addPacketBaseCourse = (packet_id) =>
  request({
    url: `/edu/packet/add/all/base_course?packet_id=${packet_id}`,
    method: 'post'
  })
  export const courseRecordList = (course_id) =>
  request({
    url: `/edu/courseRecord?course_id=${course_id}`,
    method: 'get',
  })